import { createFileRoute } from "@tanstack/react-router";
import { buildHref } from "@softmax/web-addresses";
import { AccountFrame } from "@softmax/product-ux/account";
import { AccountCredentials } from "@/features/account";
import { getCredentialsAdmission } from "@/features/account/records";
import { AccountError, AccountPending } from "@/features/account/navigation";
import { VerifiedSession } from "@/session/product-session";

export const Route = createFileRoute("/_site/account/credentials")({
  loader: ({ abortController }) =>
    getCredentialsAdmission({ signal: abortController.signal }),
  staleTime: 0,
  gcTime: 0,
  pendingComponent: AccountPending,
  errorComponent: AccountError,
  head: () => ({ meta: [{ title: "Players & credentials | Softmax" }] }),
  component: CredentialsPage,
});

function CredentialsPage() {
  const { sessionUserId } = Route.useLoaderData();
  return (
    <AccountFrame
      title="Players & credentials"
      description="Manage access to your account and player identities."
      section="credentials"
      settingsHref={buildHref({ name: "account" })}
      credentialsHref={buildHref({ name: "accountCredentials" })}
    >
      <VerifiedSession sessionUserId={sessionUserId}>
        <AccountCredentials />
      </VerifiedSession>
    </AccountFrame>
  );
}
